import Text from 'components/Text/Text';
import React, { useContext, useMemo } from 'react';
import ImgUploaderByEntityId from 'components/ImgUploader/ImgUploaderByEntityId';
import { RequestEntity } from 'types';
import { Checkbox } from 'antd';
import {
	ApkAssignmentContext,
	IApkAssignmentContext,
} from 'modules/FirmwareAndApp/Apk/ApkAssignment/apkAssignmentState/apkAssignmentContext';
import { AssignImg } from 'components/AssignImg/AssignImg';
import classNames from 'classnames';
import style from './Customers.module.scss';

const Customers: React.FC = () => {
	const { setIDsSelectedCustomers, allCustomers, searchStringForAllCustomers, IDsSelectedCustomers } =
		useContext<IApkAssignmentContext>(ApkAssignmentContext);

	const filteredAllCustomers = useMemo(() => {
		return searchStringForAllCustomers
			? allCustomers.filter((el) => el.name?.toLowerCase().includes(searchStringForAllCustomers.toLowerCase()))
			: allCustomers;
	}, [searchStringForAllCustomers, allCustomers]);

	const handleChange = (isChecked: boolean, customerID: string) => {
		if (isChecked) {
			const copyIDsSelectedCustomers = { ...IDsSelectedCustomers };
			copyIDsSelectedCustomers[customerID] = true;
			setIDsSelectedCustomers(copyIDsSelectedCustomers, true);
		} else {
			const copyIDsSelectedCustomers = { ...IDsSelectedCustomers };
			delete copyIDsSelectedCustomers[customerID];
			setIDsSelectedCustomers(copyIDsSelectedCustomers, true);
		}
	};

	return (
		<div className={style.container} data-test="Customers">
			{filteredAllCustomers.map((el) => {
				const isChecked = el.id in IDsSelectedCustomers;
				const isHaveApk = el.hasTabletApps;
				const itemClasses = classNames(style.item, {
					[style.assign]: isHaveApk,
					[style.isChecked]: isChecked,
				});

				return (
					<div className={itemClasses} key={el.id + 'mainDisplayCustomersTab'}>
						<div className={style.imageWrapper}>
							<ImgUploaderByEntityId
								resource={RequestEntity.Customers}
								entityID={el.filePath ? el.id : ''}
								photoSize="Small"
								loaderSize="small"
								noImageIdIcon="customerDefaultAvatar"
							/>
							{isHaveApk ? <AssignImg name="assignedTabletAppLabel" /> : null}
						</div>
						<div className={style.name}>
							<Checkbox
								className={style.checkbox}
								onChange={(e) => handleChange(e.target.checked, el.id)}
								checked={isChecked}
							/>
							<Text translationKey={el.name} withTooltip={true} />
						</div>
					</div>
				);
			})}
		</div>
	);
};

export default Customers;
